<div class="building-equipments-cockpit">
  <nb-tabset (changeTab)="onTabChange($event)">
    <nb-tab tabTitle="Relevante">
      <div class="list-view">
        <nb-alert>
          <div class="info-alert">
            <nb-icon icon="info-outline" pack="eva"></nb-icon>
            <span>Nur TGA relevante Prüfpunkte werden angezeigt</span>
          </div>
        </nb-alert>
        <wr-grouped-list-view [groups]="filteredInspectionEntriesGrouped$|async"
                              [searchText]="textFilter$.value"
                              (searchTextChange)="textFilter$.next($event)"
                              (selectedChange)="selectedItem$.next($event)"
                              [selected]="selectedItem$ | async">
          <ng-template wrListItem let-item>
            <div class="inspection-entry-item">
              <div class="name">{{getCheckpointString(item)}}</div>
              @if (getBuildingEquipmentCount(item); as count) {
                <div class="building-equipment-indicator"
                     nbTooltip="Hat {{ count }} {{ count | pluralize:'TGA':'TGAs' }}">
                  <nb-icon icon="cube" pack="fas"></nb-icon>
                  <span>{{ count }}</span>
                </div>
              } @else {
                <div class="building-equipment-indicator" nbTooltip="Hat keine TGAs" nbTooltipStatus="basic">
                  <nb-icon icon="slash" pack="eva" status="basic"></nb-icon>
                </div>
              }
            </div>
          </ng-template>
        </wr-grouped-list-view>
      </div>
    </nb-tab>
    <nb-tab tabTitle="Nicht relevante">
      <div class="list-view">
        <nb-alert>
          <div class="info-alert">
            <nb-icon icon="info-outline" pack="eva"></nb-icon>
            <span>Nur nicht TGA-relevante Prüfpunkte mit TGA</span>
          </div>
        </nb-alert>
        <wr-grouped-list-view
          [groups]="nonTgaRelevantInspectionEntriesGrouped$|async"
          [searchText]="textFilter$.value"
          (searchTextChange)="textFilter$.next($event)"
          (selectedChange)="selectedItem$.next($event)"
          [selected]="selectedItem$ | async"
        >
          <ng-template wrListItem let-item>
            <div class="inspection-entry-item">
              <div class="name">{{getCheckpointString(item)}}</div>
              @if (getBuildingEquipmentCount(item); as count) {
                <div class="building-equipment-indicator"
                     nbTooltip="Hat {{ count }} {{ count | pluralize:'TGA':'TGAs' }}">
                  <nb-icon icon="cube" pack="fas"></nb-icon>
                  <span>{{ count }}</span>
                </div>
              }
            </div>
          </ng-template>
        </wr-grouped-list-view>
      </div>
    </nb-tab>
    <nb-tab tabTitle="Nicht zugeordnete">
      <div class="list-view">
        <nb-alert>
          <div class="info-alert">
            <nb-icon icon="info-outline" pack="eva"></nb-icon>
            <span>TGAs des Gebäudes ohne Zuordnung zu einer Prüfpunktzeile</span>
          </div>
        </nb-alert>
        <nb-form-field class="search-field">
          <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
          <input nbInput fullWidth
                 type="text"
                 placeholder="TGA suchen"
                 [value]="unassignedTextFilter$.value"
                 (input)="unassignedTextFilter$.next($any($event.target).value)">
        </nb-form-field>
        @if (unassignedGroupsView$ | async; as view) {
          @if (view.groups.length === 0) {
            <div class="empty-state">
              @if (view.filterActive) {
                <nb-icon icon="search-outline" pack="eva" status="basic"></nb-icon>
                <span>Keine TGA gefunden</span>
              } @else {
                <nb-icon icon="checkmark-circle-2-outline" pack="eva" status="success"></nb-icon>
                <span>Alle TGAs sind zugeordnet</span>
              }
            </div>
          } @else {
            <nb-list class="unassigned-list">
              @for (group of view.groups; track group.equipment.id) {
                <ng-container ngProjectAs="nb-list-item">
                  <nb-list-item class="unassigned-group-header">
                    <div class="equipment-color-dot" [style.background-color]="group.equipment.color"></div>
                    <span class="equipment-name">{{ group.equipment.name }}</span>
                    <span class="count">{{ group.totalQuantity }}×</span>
                  </nb-list-item>
                  @for (item of group.items; track item.id) {
                    <nb-list-item class="unassigned-item">
                      <span class="section-text">{{ item.sectionText }}</span>
                      <span class="quantity">{{ item.quantity }}×</span>
                    </nb-list-item>
                  }
                </ng-container>
              }
            </nb-list>
          }
        }
      </div>
    </nb-tab>
  </nb-tabset>
  <div class="detail-view">
    @if (selectedItem$ | async; as selected) {
      <wr-cockpit-entry-detail-view [formWrapper]="formWrapper()" [entry]="selected"></wr-cockpit-entry-detail-view>
    } @else {
      <div class="no-selection">
        <nb-icon icon="slash" pack="eva"></nb-icon>
        <span>Keine Prüfpunktzeile ausgewählt</span>
      </div>
    }
  </div>
</div>
